module.exports={
  "Learn More" : "了解更多",
  "CLOSED CAPTION PREVIEW": "隐藏式字幕预览",
  "Sample Text": "示例文本",
  "Ad": "广告",
  "Skip Ad": "跳过广告",
  "LIVE": "直播",
  "GO LIVE": "现场直播",
  "CC Options": "字幕选项",
  "On": "开",
  "Off": "关",
  "Discovery": "发现",
  "Facebook Unavailable": "Facebook 不可用",
  "Facebook Success": "在 Facebook 上观看此视频",
  "Twitter Unavailable": "Twitter 不可用",
  "Twitter Success": "在 Twitter 上观看此视频",
  "Post Title": "发布成功",
  "Account Configure": "请在设备上设置您的帐号",
  "Discover": "发现",
  "Up next": "下一个",
  "Video Quality": "视频质量",
  "Share": "分享",
  "Start at": "开始于",
  "Embed": "嵌入的",
  "Email": "电子邮件",
  "Check out this video": "我发现一个您可能会感兴趣的视频！点开看看： ",
  "To": "收件人",
  "Subject": "主题",
  "Message": "消息",
  "name@email.com": "name@email.com",
  "Optional Message": "可选消息",
  "Send": "发送",
  "RELOAD YOUR SCREEN OR TRY SELECTING A DIFFERENT VIDEO": "重新加载屏幕或尝试选择其他视频",
  "THIS IS NOT WORKING! :(": "无法正常运作！:(",
  "NETWORK ERROR": "网络错误",
  "Cannot Contact Server": "无法联系服务器",
  "SAS ERROR": "SAS 错误",
  "Invalid Authorization Response": "授权响应无效",
  "SAS GEO ERROR": "SAS 地区错误",
  "This video is not authorized in your location": "此视频未获得您所在地区的授权",
  "SAS DOMAIN ERROR": "SAS 域错误",
  "This video is not authorized for your domain": "此视频未获得您的域授权",
  "VIDEO NOT AVAILABLE YET": "视频尚不能播放",
  "This video will be available soon": "此视频很快即可播放",
  "VIDEO COMING SOON!": "即将推出视频！",
  "This video is not available yet": "此视频尚不能播放",
  "You may need to refresh the page to access the video after it becomes available" : "视频变成可播放后，您可能需要刷新页面以观看该视频",
  "VIDEO NO LONGER AVAILABLE": "视频不再有效",
  "This video is no longer available": "此视频不再有效",
  "SAS DEVICE ERROR": "SAS 设备错误",
  "This video is not authorized for playback on this device": "此视频未获得在此设备上回放的授权",
  "SAS PROXY ERROR": "SAS 代理错误",
  "An anonymous proxy was detected. Please disable the proxy and retry.": "检测到匿名代理。请禁用该代理并重试。",
  "CONCURRENT STREAMS NUMBER EXCEEDED": "超过并发流数",
  "You have exceeded the maximum number of concurrent streams": "您已超过最大并发流数",
  "DEVICE BINDING ERROR": "设备绑定错误",
  "Device binding failed": "设备绑定失败",
  "DEVICE ID TOO LONG": "设备 ID 太长",
  "Device ID is too long": "设备 ID 太长",
  "INVALID PLAYER TOKEN": "播放器标记无效",
  "Invalid Ooyala Player token": "Ooyala 播放器标记无效",
  "AUTHORIZATION ERROR": "授权错误",
  "Unable to register this device to this account, as the maximum number of authorized devices has already been reached. Error Code 22": "无法将此设备注册到该帐号，因为已达到授权设备的最大数量。错误代码 22",
  "Unable to access this content, as the maximum number of devices has already been authorized. Error Code 29": "无法访问此内容，因为授权设备数量已达到最大值。错误代码 29",
  "Please remove one of your authorized devices to enable this device.": "请删除其中一个已授权设备以启用此设备。",
  "LICENSE ERROR": "许可证错误",
  "General error acquiring license": "获得许可证一般错误",
  "DRM SERVER ERROR": "DRM 服务器错误",
  "DRM server error": "DRM 服务器错误",
  "INVALID ENTITLEMENTS ERROR": "无效权限错误",
  "User Entitlement Terminated - Stream No Longer Active for the User": "用户权限已终止 - 流对该用户不再有效",
  "INVALID HEARTBEAT": "心跳无效",
  "Invalid heartbeat response": "心跳响应无效",
  "INVALID CONTENT": "内容无效",
  "INVALID METADATA": "元数据无效",
  "Invalid Metadata": "元数据无效",
  "PLAYBACK ERROR": "回放错误",
  "Could not play the content": "无法播放内容",
  "PLAYBACK STREAM ERROR": "回放流错误",
  "This video isn't encoded for your device": "此视频未针对您的设备进行编码",
  "PLAYBACK LIVESTREAM ERROR": "回放直播流错误",
  "Live stream is off air": "直播流已停播",
  "PLAYBACK NETWORK ERROR": "回放网络错误",
  "Network connection temporarily lost": "网络连接暂时中断",
  "UNPLAYABLE CONTENT ERROR": "不可播放的内容错误",
  "This video is not playable on this player": "此视频不能在此播放器上播放",
  "INVALID EXTERNAL ID": "外部 ID 无效",
  "Invalid External ID": "外部 ID 无效",
  "EMPTY CHANNEL ERROR": "空白通道错误",
  "This channel is empty": "此通道为空",
  "EMPTY CHANNEL SET ERROR": "空白通道集错误",
  "This channel set is empty": "此通道集为空",
  "CHANNEL CONTENT ERROR": "通道内容错误",
  "This channel is not playable at this time": "当前此通道不可播放",
  "SOMETHING NOT RIGHT! THERE SHOULD BE VIDEOS HERE.": "出错了！此处应有视频。",
  "(Try Clicking The Discover Button Again On Reload Your Page)": "（尝试再次单击“发现”按钮或重新加载页面）",
  "Something happened while we were trying to play your video! Click replay or simply reload your page.": "尝试播放您的视频时发生问题！单击重新播放或只是重新加载页面。",
  "Language": "语言",
  "Color Selection": "颜色选择",
  "Caption Opacity": "字幕不透明度",
  "Font Type": "字体类型",
  "Font Size": "字体大小",
  "Text Enhancements": "文本增强",
  "Text color": "文本颜色",
  "Background color": "背景颜色",
  "Window color": "窗口颜色",
  "Transparent": "透明",
  "White": "白色",
  "Blue": "蓝色",
  "Magenta": "品红",
  "Green": "绿色",
  "Yellow": "黄色",
  "Red": "红色",
  "Cyan": "青色",
  "Black": "黑色",
  "Text opacity": "文本不透明度",
  "Background opacity": "背景不透明度",
  "Window opacity": "窗口不透明度",
  "Font size": "字体大小",
  "Small": "小",
  "Medium": "中",
  "Large": "大",
  "Extra Large": "超大",
  "Text enhancement": "文本增强",
  "Uniform": "均匀",
  "Depressed": "凹陷",
  "Raised": "凸起",
  "Shadow": "阴影",
  "Play": "播放",
  "Replay": "重播",
  "Pause": "暂停",
  "Mute": "静音",
  "Unmute": "取消静音",
  "Closed Captions":"隐藏式字幕",
  "Full Screen": "全屏",
  "Exit Full Screen": "退出全屏",
  "More Options": "更多选项",
  "Audio": "音频",
  "Subtitles": "字幕",
  "Undefined language": "未定义语言",
  "No linguistic content": "没有语言内容",
  "Speed": "速度",
  "Normal": "正常"
}
